"use strict";

export default {
    _handleBackButton(e) {
        $(e.currentTarget)
            .closest(".cbp-hrmenu-main-item")
            .removeClass("cbp-hropen");
    },

    _handleItemClick(e) {
        if (
            $(e.target).closest(".cbp-hrsub").length ||
            $(e.target).next(".collapse").length === 0
        ) {
            return;
        }

        e.preventDefault();

        $(e.currentTarget).addClass("cbp-hropen");
    },

    init() {
        $(document).on(
            "click touch",
            ".cbp-hrmenu.mobile .btn-back",
            this._handleBackButton.bind(this)
        );

        $(document).on(
            "click touch",
            ".cbp-hrmenu.mobile .cbp-hrmenu-main-item",
            this._handleItemClick.bind(this)
        );
    },
};
